import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appFocusMe]',
  standalone: false,
})
export class FocusMeDirective implements AfterViewInit {

  @Input({
    alias: 'focus-me', transform: (v: string | boolean | null): boolean => {
      if (v === null || typeof v === 'undefined') {
        return true;
      } else if (typeof v === 'string') {
        return true;
      }
      return v;
    }
  }) focusMe?: boolean = true;

  constructor(private element: ElementRef) {
  }

  ngAfterViewInit(): void {
    if (this.focusMe) {
      setTimeout(() => {
        this.element.nativeElement.focus();
      }, 100);
    }
  }
}